export default __webpack_public_path__ + "static/media/cp_geo_om.cf72330b.svg";